import React from 'react'

export const hawaiiSetupVars = {
  siteId: 'hawaii',
  pathPrefix: '/hi',
  menuHeader: "Discover Hawaii's Solution for:",
  appUrl: 'https://hi.headed2.com',
  logoImg: '/images/assets/hawaii/horizontal/dark.svg',
  headerTitle: `The Hawaii CareerExplorer is a system designed for Hawaii`
}
